<template>
  <div class="add-profile-wrapper">
    <h1>Dodaj profil</h1>
    <div>
      <form>
        <label for="profile-username">Login</label>
        <input
          v-model="username"
          id="profile-username"
          placeholder="Login do profilu Instagram..."
          type="text"
          required
        >
        <label for>Hasło</label>
        <input
          v-model="password"
          placeholder="Hasło do profilu Instagram.."
          type="password"
          required
        >
        <p class="error" v-for="error in errors" :key="error">{{ error }}</p>
      </form>
      <button @click.prevent="addProfile">Dodaj</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddProfileModal",
  methods: {
    addProfile() {
      this.$store.dispatch('addProfile');
      this.$store.commit('hideModal');
      this.$store.dispatch('showLoadingModal', true);
    }
  },
  computed: {
    username: {
      get() {
        return this.$store.getters.profileToAddInfo.username;
      },
      set(value) {
        this.$store.commit('updateProfileToAddUsername', value);
      }
    },
    password: {
      get() {
        return this.$store.getters.profileToAddInfo.password;
      },
      set(value) {
        this.$store.commit('updateProfileToAddPassword', value);
      }
    },
    errors() {
      return this.$store.getters.addProfileErrors;
    }
  }
};
</script>
<style lang="scss">
form {
  margin: 25px;
}

.add-profile-wrapper {
  width: 60vw;
  @media (max-width: 768px) {
    width: 95vw;
  }
}
</style>
